import { Button } from '@/shared/ui/Button'

type PrizesListEmptyProps = {
  filtered?: boolean
  onClearFilter?: () => void
}

export const PrizesListEmpty = ({
  filtered,
  onClearFilter
}: PrizesListEmptyProps) => (
  <div className="py-10 text-center">
    <p className="mb-2 text-2xl" aria-hidden>
      🎁
    </p>
    <p className="mb-2 text-sm font-bold text-gray-800">
      {filtered
        ? 'Nenhum concurso neste filtro'
        : 'Nenhum concurso disponível'}
    </p>
    <p className="mb-4 text-gray-700">
      {filtered
        ? 'Tente outro filtro para ver mais concursos.'
        : 'Novos concursos serão liberados em breve.'}
    </p>
    {filtered && onClearFilter && (
      <Button
        variant="secondary"
        size="sm"
        showTrailingIcon={false}
        onClick={onClearFilter}
      >
        Ver todos
      </Button>
    )}
  </div>
)
